import { render, staticRenderFns } from "./SupervisorItem.vue?vue&type=template&id=6e55c2ff&scoped=true&"
import script from "./SupervisorItem.vue?vue&type=script&lang=js&"
export * from "./SupervisorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55c2ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
